import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setMachineID } from "../../Landing/Actions";

const mapStatetoProps = state => {

    const { landing } = state;
    return {
        machineID:landing.machineID,
        kitchenId:landing.kitchenId
    }

};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({
        setMachineID:setMachineID,
    },
    dispatch
    )
});

export default connect(mapStatetoProps,mapDispatchToProps);